export default __webpack_public_path__ + "static/media/marker.14bced29.svg";